"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M20.647 21.62a29.948 29.948 0 0 1-.771-5.178 9.991 9.991 0 0 1 .611-2.945 5.754 5.754 0 0 0 3.631-5.748 6.111 6.111 0 1 0-12.222 0 5.747 5.747 0 0 0 3.611 5.744 10.477 10.477 0 0 1 .622 2.949 31.344 31.344 0 0 1-.778 5.179c-2.923.149-10 1.768-12.48 2.351A1.146 1.146 0 0 0 2 25.1v3.729A1.154 1.154 0 0 0 3.146 30h29.711A1.154 1.154 0 0 0 34 28.836V25.1a1.146 1.146 0 0 0-.873-1.131c-2.476-.581-9.554-2.2-12.48-2.349z" }),
  React.createElement("rect", { height: "2", rx: ".5", ry: ".5", width: "28", x: "4", y: "32" })
);

